import {
  useSuggestions 
} from "@/hooks/SearchBar/useSuggestions"
import {
  Fragment 
} from "react"

import SuggestedProducts from "./suggestedProducts"

const Suggestions = (props) => {
  const {
    displayResult,
    filters,
    products,
    searchValue,
    setVisible,
    visible,
    afterSubmit,
  } = props
  const {
    items 
  } = products

  const talonProps = useSuggestions({
    displayResult,
    filters,
    items,
    setVisible,
    visible,
    afterSubmit,
  })
  const {
    onNavigate, shouldRender 
  } = talonProps

  // render null without data
  if (!shouldRender) {
    return null
  }

  return (
    <Fragment>
      <SuggestedProducts onNavigate={onNavigate} products={items} />
    </Fragment>
  )
}

export default Suggestions
